module.exports = __webpack_public_path__ + "img/banner9.86e35459.png";